import type React from 'react';

import { Chip } from '@mui/material';
import { Resources } from '@ragu-components/ord-resources';

import { openResourceInNewTab } from 'src/lib/openResourceInNewTab';

import type { ChipProps } from '@mui/material';
import type { Agent } from '@ragu-components/ord-types';

export interface QueueChipProps extends Omit<ChipProps, 'label'> {
  record: Agent;
}

export const QueueChip = ({ record, ...chipProps }: QueueChipProps): React.ReactElement => {
  return (
    <Chip
      label={record.queue?.name}
      variant='outlined'
      size='small'
      onClick={() => {
        if (record.queue !== undefined) {
          openResourceInNewTab(Resources.queues, record.queue.id);
        }
      }}
      sx={{ cursor: 'pointer' }}
      {...chipProps}
    />
  );
};

export default QueueChip;
